export default __webpack_public_path__ + "static/media/image_boy.64ac6bf8.svg";